/** Account page + trial banner. */
export const account = {
  // Workspace-wide trial countdown / trial-expired banner.
  trial: {
    expired: "Your free trial has ended. Playback on your devices is stopped.",
    endsTomorrow: "Your free trial ends tomorrow.",
    endsInDays: "Your free trial ends in {days} days.",
    askOwner: " Ask your workspace owner to subscribe.",
    reactivate: "Reactivate",
    addPaymentMethod: "Add payment method",
    dismiss: "Dismiss for today",
  },

  // Failure state when the account/session can't be loaded.
  error: {
    title: "Couldn't load your account",
    description:
      "Something went wrong while loading your account. Check your connection and try again.",
  },

  // Destructive "danger zone" card copy.
  dangerZone: {
    description:
      "Permanently removes your account, workspaces you own, and your access to all other workspaces. This cannot be undone.",
  },

  // Delete-account button + confirmation dialog.
  delete: {
    button: "Delete account",
    deleting: "Deleting...",
    dialogTitle: "Delete account?",
    dialogDescriptionStart: "This will permanently delete your account",
    dialogDescriptionEnd:
      ", every workspace you own, and your memberships elsewhere. Type your email address to confirm.",
    emailPlaceholder: "your@email.com",
  },

  toast: {
    deleteFailed: "Failed to delete account",
  },
} as const;
